<div class="component-container">
  <div class="progress-card-heading text-type-15">{{ heading }}</div>
  <div class="progress-bar">
    <div [style.width.%]="percent" class="progress"></div>
  </div>
  @if (caption) {
    <div class="caption text-type-14">{{ caption }}</div>
  }
  @if (captionPrefix) {
    <div class="caption text-type-14">
      <span>{{ captionPrefix }}</span>
      <span class="caption-value">{{ captionValue }}</span>
      <span>{{ captionSuffix }}</span>
    </div>
  }
</div>
